export default class extends HTMLElement {
  connectedCallback () {
    this.passwordInput = this.querySelector('[data-password-meter]')
    this.confirmInput = this.querySelector('[data-password-match]')
    this.termsCheckbox = this.querySelector('[data-terms-toggle][type="checkbox"]')
    this.registerBtn = this.querySelector('#register-btn')
    this.meter = this.querySelector('#password-meter')
    this.matchError = this.querySelector('#password-match-error')
    this.matchOk = this.querySelector('#password-match-ok')

    if (!this.passwordInput || !this.registerBtn) return

    // Password complexity meter
    this.passwordInput.addEventListener('focus', () => { this.meter.style.display = 'flex' })
    this.passwordInput.addEventListener('blur', () => {
      if (!this.passwordInput.value) this.meter.style.display = 'none'
    })

    this.passwordInput.addEventListener('input', () => {
      const val = this.passwordInput.value
      const rules = {
        length: val.length >= 8,
        uppercase: /[A-Z]/.test(val),
        number: /[0-9]/.test(val),
        special: /[^A-Za-z0-9\s]/.test(val)
      }
      Object.entries(rules).forEach(([key, passed]) => {
        const el = this.meter.querySelector(`[data-rule="${key}"]`)
        if (el) {
          el.classList.toggle('text-red-400', !passed)
          el.classList.toggle('text-green-400', passed)
        }
      })
    })

    // Confirm password match
    if (this.confirmInput) {
      this.confirmInput.addEventListener('input', () => {
        if (!this.confirmInput.value) {
          this.confirmInput.classList.remove('border-red-400')
          this.matchError.classList.add('hidden')
          this.matchOk.classList.add('hidden')
          return
        }
        const match = this.passwordInput.value === this.confirmInput.value
        this.confirmInput.classList.toggle('border-red-400', !match)
        this.confirmInput.classList.toggle('border-white', match)
        this.matchError.classList.toggle('hidden', match)
        this.matchOk.classList.toggle('hidden', !match)
      })
    }

    // Terms toggle — enable/disable register button
    if (this.termsCheckbox) {
      // Sync on init (handles re-render after failed submission)
      this.registerBtn.disabled = !this.termsCheckbox.checked

      this.termsCheckbox.addEventListener('change', () => {
        this.registerBtn.disabled = !this.termsCheckbox.checked
      })
    }
  }
}
